/*eslint-env browser*/

function removeFromDash (lang) {
    return lang.split("-")[0]
}


function urlLang () {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get("lang")
}


function navigatorLang () {
    return navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage)
}


export default function (params = {}) {
    const acceptedLang = params.accepted || ["fr", "en"]
    const defaultLang  = params.default  || "en"

    const langInput = urlLang() || navigatorLang()

    let lang = removeFromDash(langInput)

    if (acceptedLang && !acceptedLang.includes(lang)) {
        lang = defaultLang
    }

    return lang
}

